
export const resetPasswordMessage = (code: string) => {
	switch (code) {
		case 'UserNotFoundException':
			return 'Email address not recognised, please try again.';
		case 'CodeDeliveryFailureException':
			return 'Your verification code could not be sent. Please contact support for assistance.';
		case 'InvalidParameterException':
			return 'Please enter a valid email address.';
		case 'TooManyFailedAttemptsException':
			return 'Too many attempts to reset password have been made, please try again later.';
		default:
			return 'There was an error trying to reset your password. Please contact support for assistance.';
	}
};

export const resetConfirmPasswordMessage = (code: string, message: string) => {
	switch (code) {
		case 'InvalidParameterException':
			return 'Please make sure your new password meets the required criteria.';
		case 'InvalidPasswordException':
			if (message.includes('cannot be used for security reasons')) {
				return 'Your new password is potentially insecure, please try another.';
			} else {
				return 'Please make sure your new password meets the required criteria.';
			}
		case 'CodeMismatchException':
			return 'The verification number you provided did not match what was expected. Please make sure you are using the latest number we emailed you.';
		case 'LimitExceededException':
			return 'Reset attempt limit exceeded, please try again later.';
		default:
			return 'There was an error trying to reset your password. Please contact support for assistance.';
	}
};
